'use client';

import clsx from 'clsx';
import { StaticImageData } from 'next/image';
import { PropsWithChildren } from 'react';
import styles from './TeaserCard.module.scss';

export type TeaserCardProps = PropsWithChildren<{
  variant: 'blue' | 'surrogate' | 'orange';
  backgroundImage: StaticImageData;
  className?: string;
}>;

export const TeaserCard = ({
  children,
  variant,
  backgroundImage,
  className,
}: TeaserCardProps) => {
  const classes = clsx(styles.base, styles[variant], className);

  return (
    <div
      className={classes}
      style={{
        backgroundImage: ` url('${backgroundImage?.src || backgroundImage}')`,
      }}
    >
      <div className={styles.content}>{children}</div>
    </div>
  );
};
